export default "__VITE_ASSET__BScZC_JI__"